import DayOfStats from './DayOfStats';

export default DayOfStats;
